<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('settings.transaltion.editTranslation') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="service-translation-edit-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('ui.language') }}:
            </label>

            <d-form-select
              v-model="language"
              :options="languageOptions" />
          </div>

          <div class="form-group">
            <label>
              <template v-if="isServiceGroup">
                {{ $t('service.group.serviceGroupName') }}:
              </template>
              <template v-else>
                {{ $t('service.serviceName') }}:
              </template>
            </label>

            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="name" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div
            v-if="!isServiceGroup"
            class="form-group">
            <label for="intro">
              {{ $t('ui.shortDescription') }}:
            </label>

            <validation-provider
              rules="required"
              name="intro"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="intro" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div
            v-if="!isServiceGroup"
            class="form-group">
            <label for="description">
              {{ $t('service.serviceDescription') }}:
            </label>

            <validation-provider
              rules="required"
              name="description"
              v-slot="{ errors }">
              <d-textarea
                :state="errors.length ? 'invalid' : null"
                :value.prop="description"
                v-model="description" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div
            v-if="!isServiceGroup"
            class="form-group">
            <label for="catalog_url">
              {{ $t('service.catalogUrl') }}:
            </label>

            <validation-provider
              rules="valid-url"
              name="catalog_url"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="catalog_url" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        {{ $t('settings.transaltion.editTranslation') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'service-translation-edit-popup',
  props: {
    serviceID: {
      default: 0,
      type: Number
    },
    serviceGroupID: {
      default: 0,
      type: Number
    },
    translationData: {
      default: () => ({}),
      type: Object
    },
    languages: {
      default: () => ([]),
      type: Array
    }
  },
  computed: {
    isServiceGroup () {
      return !this.serviceID && !!this.serviceGroupID;
    },
    languageOptions () {
      return this.languages.filter(language => language.id > 1).map(language => ({
        value: language.id,
        text: language.name
      }));
    }
  },
  data () {
    return {
      language: this.translationData.language_id,
      translationID: this.translationData.id,
      name: this.translationData.name,
      intro: this.translationData.intro,
      description: this.translationData.description,
      catalog_url: this.translationData.catalog_url
    };
  },
  methods: {
    handleClose (translationID) {
      let eventName = 'service-translation-edit-popup-close';

      if (this.isServiceGroup) {
        eventName = 'service-group-translation-edit-popup-close';
      }

      this.$bus.$emit(eventName, translationID);
    },
    validateForm () {
      FormUtils.validate(this.$refs['service-translation-edit-form'], this.saveTranslation);
    },
    saveTranslation () {
      let endpointUrl = '/services/translations/update/' + this.translationID;
      let dataToSend = {
        service_id: this.serviceID,
        language_id: this.language,
        name: this.name,
        intro: this.intro,
        description: this.description,
        catalog_url: this.catalog_url
      };

      if (this.isServiceGroup) {
        endpointUrl = '/services/groups/translations/update/' + this.translationID;
        dataToSend = {
          group_id: this.serviceGroupID,
          language_id: this.language,
          name: this.name
        };
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: dataToSend,
        successTitle: this.$t('settings.transaltion.translationEditSuccessTitle'),
        successText: this.$t('settings.transaltion.translationEditSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.transaltion.translationEditErrorText'),
        successAction: res => {
          let eventName = 'service-reload-translations';

          if (this.isServiceGroup) {
            eventName = 'service-group-reload-translations';
          }

          this.$bus.$emit(eventName);
          this.handleClose(res.id);
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
